import React, { useEffect, useState } from 'react';
import { getUserPaymentHistory } from '../api/paymentApi';
import { Helmet } from 'react-helmet-async';

const UserPaymentHistory: React.FC = () => {
  const [payments, setPayments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const data = await getUserPaymentHistory();
        setPayments(data || []);
      } catch {
        setPayments([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen p-6">
      <Helmet>
        <title>내 결제내역 | BIN-GO</title>
        <meta name="description" content="내가 결제한 내역을 한눈에!" />
        <meta property="og:title" content="내 결제내역 | BIN-GO" />
        <meta property="og:description" content="나의 결제 이력/리스트." />
      </Helmet>
      <h1 className="text-2xl font-bold mb-4">내 결제내역</h1>
      {loading ? (
        <div>로딩중...</div>
      ) : payments.length === 0 ? (
        <div>결제내역이 없습니다.</div>
      ) : (
        <ul className="space-y-3">
          {payments.map((pay) => (
            <li key={pay.id} className="border rounded-md p-4">
              <div>거래번호: {pay.transaction_id}</div>
              <div>주문번호: {pay.order_id}</div>
              <div>결제금액: {pay.amount?.toLocaleString()} 원</div>
              <div>결제방식: {pay.pay_type}</div>
              <div>일시: {pay.created_at ? new Date(pay.created_at).toLocaleString() : ''}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UserPaymentHistory;
